export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11600.2ec91cf4.jpg";